// extracted by mini-css-extract-plugin
export default {"headerIcon":"post-list__headerIcon__jR51C"};